import React from "react";
import BrandKitSearchInput from "views/components/BrandKit/BrandKitSearch/BrandKitSearchInput";
import BrandKitSearchTextButton from "views/components/BrandKit/BrandKitSearch/BrandKitSearchTextButton";
import BrandKitLogoOps from "./BrandKitLogoOps";
import PlusIcon from "views/components/icons/PlusIcon";
import ExitStandardisedIcon from "views/components/icons/ExitStandardisedIcon";
import BrandKitSearchSpacer from "../BrandKitSearch/BrandKitSearchSpacer";
import BrandKitSortButton from "../BrandKitSortButton";
import { AddImageButton } from "views/components";
import common from "../common.module.css";
import { STATIC_ASSET_FILE_TYPES } from "lib/constants";
import { keyCodes } from "lib";

export class BrandKitLogosSearch extends React.Component {
  constructor(props) {
    super(props);
    this.setQueryString = BrandKitLogoOps.setQueryString.bind(this);
    this.handleSortUpdate = BrandKitLogoOps.handleSortUpdate.bind(this);
    this.onAddImageButtonClick =
      BrandKitLogoOps.onAddImageButtonClick.bind(this);
    this.handleAddLogo = BrandKitLogoOps.handleAddLogo.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.state = {
      searchTerm: ""
    };
  }

  handleKeyDown(event) {
    if (event.keyCode === keyCodes.enterKey) {
      this.setQueryString({ term: this.props.searchTerm });
    }
  }

  render() {
    const { isBrandManager, qsFolderId } = this.props;

    return (
      <>
        <BrandKitSearchInput
          onChange={term => {
            this.props.setBrandKitState({ searchTerm: term }, "logos");
          }}
          onClear={() => {
            this.props.setBrandKitState({ searchTerm: null }, "logos");
            this.setQueryString(null);
          }}
          placeholder="Search for Brand Logos by name"
          value={this.props.searchTerm || ""}
          onKeyDown={this.handleKeyDown}
        />

        {isBrandManager && (
          <>
            <BrandKitSortButton
              sortKey={this.props.sortKey}
              onSortUpdate={this.handleSortUpdate}
              filterSmartImages={this.props.filterSmartImages}
              toggleSmartImageFilter={() => {
                this.props.setBrandKitState(
                  { filterSmartImages: !this.props.filterSmartImages },
                  "logos"
                );
              }}
              smartImageFilter={true}
            />

            {qsFolderId === null && (
              <>
                <BrandKitSearchTextButton
                  Icon={() => (
                    <PlusIcon
                      color="#3184fc"
                      size="18px"
                      style={{ transform: "rotate(-90deg)" }}
                    />
                  )}
                  onClick={() =>
                    this.props.setBrandKitState(
                      { isAddingFolder: true },
                      "logos"
                    )
                  }
                  title="New Folder"
                />

                <BrandKitSearchSpacer />
              </>
            )}

            <AddImageButton
              acceptedFileTypes={STATIC_ASSET_FILE_TYPES}
              className={common.uploadButtonPrependError}
              onChange={({ file, onSuccess }) =>
                this.handleAddLogo(file, onSuccess)
              }
              onClick={this.onAddImageButtonClick}
              image={
                <BrandKitSearchTextButton
                  Icon={() => (
                    <ExitStandardisedIcon
                      color="#3184fc"
                      size="18px"
                      style={{ transform: "rotate(-90deg)" }}
                    />
                  )}
                  title="Upload"
                />
              }
              isMulti
            />
          </>
        )}
      </>
    );
  }
}

export default BrandKitLogosSearch;
